module.exports = __webpack_public_path__ + "static/media/done-14px.188a603e.svg";